import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ResumenTareasService } from 'src/app/services/resumen-tareas.service';

import { MapsAPILoader } from '@agm/core';

declare var google: any; // Declara la variable global de Google Maps
var negocio: any;
var agencia: any;

import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-FragmentMapaValidaroGeo',
  templateUrl: './FragmentMapaValidaroGeo.component.html', // Usa solo templateUrl
  styleUrls: ['./FragmentMapaValidaroGeo.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FragmentMapaValidaroGeo implements AfterViewInit  {
  nombre: string = '';
nit: string = '';
departamento: string = '';
ciudad: string = '';
barrio: string = '';
direccion: string = '';
  readonly apiKeyHere = '9oZR5QIeDIOZJgusBRD1JLI-qo-n4vq5cH5dFLINodc';

resultadoAgente0: any[] = [];
resultadoAgente3: any[] = [];
resultadoAgente1: any = null;
viewportPoints: any[] = [];
resultadoAgente4: any[] = [];
private marcadores: google.maps.Marker[] = [];
private circulos: google.maps.Circle[] = [];

  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;

  map!: google.maps.Map;

  constructor(private http: HttpClient,private mapsAPILoader: MapsAPILoader,public resumenTareasService: ResumenTareasService) {
  
    }

  ngAfterViewInit(): void {
    // Centro en Bogotá, Colombia
    const colombia = { lat: 4.710989, lng: -74.072090 };

    this.map = new google.maps.Map(this.mapContainer.nativeElement, {
      center: colombia,
      zoom: 6
    });

    // Agrega un marcador
    new google.maps.Marker({
      position: colombia,
      map: this.map,
      title: 'Colombia'
    });
  }

resetearMapa(): void {
  const colombia = { lat: 4.5709, lng: -74.2973 }; // Centro inicial
  this.map = new google.maps.Map(this.mapContainer.nativeElement, {
    center: colombia,
    zoom: 6
  });
}


geocodificar(direccion: string): Promise<any[]> {
  const url = `https://geocode.search.hereapi.com/v1/geocode?q=${encodeURIComponent(direccion)}&apiKey=${this.apiKeyHere}`;

  return this.http.get(url).toPromise().then((res: any) => {
    if (res && res.items && res.items.length > 0) {
      console.log('📍 Resultados HERE (todas las coincidencias):');
      res.items.forEach((item: any, index: number) => {
        console.log(`🧭 Resultado ${index + 1}:`);
        console.log('Dirección:', item.address.label);
        console.log('Lat:', item.position.lat);
        console.log('Lng:', item.position.lng);
        console.log('-----------------------------------');
      });
      return res.items; // retorna todos los resultados
    } else {
      console.warn('⚠️ No se encontraron resultados en HERE');
      return [];
    }
  }).catch((error) => {
    console.error('❌ Error en geocodificar:', error);
    throw error;
  });
}




buscarDireccion(): void {
  const partes = [
    this.direccion,
    this.barrio,
    this.ciudad,
    this.departamento,
    'Colombia'
  ].filter(Boolean);

    this.resetearMapa();

  const direccionCompleta = partes.join(', ');

  // Ejecutar Agente 1 en paralelo
  this.geocodeNextItemA2Uno(direccionCompleta);

  this.geocodeAgente3DesdeBusqueda()

  // Ejecutar Agente HERE (con HERE Maps)
this.geocodificar(direccionCompleta).then((itemsHere) => {
    this.resultadoAgente4 = itemsHere; // ← guarda todos los resultados
  if (itemsHere.length > 0) {
    // Puedes usar solo el primero para mostrarlo en el mapa o todos si quieres

    itemsHere.forEach((item, index) => {
      const lat = item.position.lat;
      const lng = item.position.lng;
      const location = new google.maps.LatLng(lat, lng);

      new google.maps.Marker({
        position: location,
        map: this.map,
        label: `${index + 1}`,
        title: `Agente HERE ${index + 1}`
      });

      new google.maps.Circle({
        strokeColor: '#1976d2',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1976d2',
        fillOpacity: 0.35,
        map: this.map,
        center: location,
        radius: 100
      });
    });
  }
});



  // Ejecutar Agente 0 (Google Maps)
  this.mapsAPILoader.load().then(() => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: direccionCompleta }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();

        const item: any = {
          agente: 'Agente 0',
          nombre: this.nombre,
          nit: this.nit,
          direccionIngresada: direccionCompleta,
          formattedAddress: results[0].formatted_address,
          lat,
          lng,
          postalCode: null
        };

        const components = results[0].address_components;
        const postalCodeComponent = components.find(function (c) {
          return c.types.indexOf('postal_code') !== -1;
        });
        if (postalCodeComponent) {
          item.postalCode = postalCodeComponent.short_name;
        }

        this.resultadoAgente0 = item;

        // Pintar marcador Agente 0
        this.map.setCenter(location);
        this.map.setZoom(15);
  new google.maps.Marker({
  position: location,
  map: this.map,
  label: '0',
  title: 'Agente 0'
});

// Dibuja un círculo de 30 metros (verde para Agente 0)
new google.maps.Circle({
  strokeColor: '#4caf50',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#4caf50',
  fillOpacity: 0.35,
  map: this.map,
  center: { lat, lng },
  radius: 100
});

        console.log('✅ Agente 0:', item);
      } else {
        console.error('❌ Error Agente 0:', status);
      }
    });
  });
}
async geocodeNextItemA2Uno(direccionCompleta: string): Promise<void> {
  try {
    console.log('➡ Consulta Agente 1:', direccionCompleta);

    const googleData = await this.resumenTareasService
      .validateAddress(direccionCompleta, '', 'CO')
      .toPromise();

    if (googleData && googleData.result) {
      const geo = googleData.result.geocode && googleData.result.geocode.location;
      const address = googleData.result.address;

      const item: any = {
        agente: 'Agente 1',
        formattedAddress: address ? address.formattedAddress : '',
        lat: geo.latitude,
        lng: geo.longitude,
        postalCode: null
      };

      const postal = (address.addressComponents || []).find(function (c) {
        return c.componentType === 'postal_code';
      });
      item.postalCode = postal && postal.componentName ? postal.componentName.text : null;

      this.resultadoAgente1 = googleData.result;

      // Pintar marcador Agente 1
      this.map.setCenter({ lat: item.lat, lng: item.lng });
      this.map.setZoom(15);
      new google.maps.Marker({
  position: { lat: item.lat, lng: item.lng },
  map: this.map,
  label: '1',
  title: 'Agente 1'
});

// Dibuja un círculo de 30 metros (azul para Agente 1)
new google.maps.Circle({
  strokeColor: '#2196f3',      // azul
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#2196f3',
  fillOpacity: 0.35,
  map: this.map,
  center: { lat: item.lat, lng: item.lng },
  radius: 30
});

      console.log('✅ Agente 1:', item);
    } else {
      console.warn('⚠ Agente 1 no devolvió resultados');
    }
  } catch (error) {
    console.error('❌ Error Agente 1:', error);
  }
}

async geocodeAgente3DesdeBusqueda(): Promise<void> {
  try {
    const consultaData = {
      nombre: this.nombre || '',
      direccion: (this.direccion || '').replace(/Local/gi, ''),
      location: this.ciudad + ' ' + this.barrio,
      gl: 'co',
      hl: 'es',
      nit: this.nit || '',
      incluirLog: true,
      departamento: this.departamento,
    };

    console.log('consultaData (Agente 3):', consultaData);

    const response = await this.resumenTareasService.consultadireccionmaps(consultaData).toPromise();
    console.log('Respuesta Agente 3:', response);

    var mejorCoincidencia = null;
    var razon = 'Coincidencia obtenida directamente del servicio.';
    var address = null;
    var title = null;

    // Caso principal: mejorCoincidencia del finalResult
    if (response && response.finalResult && response.finalResult.mejorCoincidencia) {
      mejorCoincidencia = response.finalResult.mejorCoincidencia;
      title = mejorCoincidencia.title;
      address = mejorCoincidencia.address;
    }

    // Fallback: /evaluar-direcciones-marca
    if (
      !mejorCoincidencia &&
      response &&
      response.steps &&
      response.steps.length > 0
    ) {
      for (var i = 0; i < response.steps.length; i++) {
        var step = response.steps[i];
        if (
          step.servicio === '/evaluar-direcciones-marca' &&
          step.resultado &&
          step.resultado.mejorCoincidencia
        ) {
          mejorCoincidencia = step.resultado.mejorCoincidencia;

          // Extraer nombre y dirección como title y address
          title = mejorCoincidencia.nombre;
          address = mejorCoincidencia.direccion;

          // Extraer razon del comentario global de ese paso
          razon = step.resultado.comentario || 'Coincidencia parcial encontrada.';
          break;
        }
      }
    }

    // Validar existencia de coordenadas antes de pintar
    if (
      mejorCoincidencia &&
      mejorCoincidencia.place &&
      mejorCoincidencia.place.latitude &&
      mejorCoincidencia.place.longitude
    ) {
      var place = mejorCoincidencia.place;
      var center = { lat: place.latitude, lng: place.longitude };

      // Construcción explícita para la vista
      var coincidenciaFinal = {
        title: title,
        address: address,
        razon: razon,
        place: place
      };

      var resultado: any = {};
      if (response && response.finalResult) {
        var original = response.finalResult;
        if (original.origen) resultado.origen = original.origen;
        if (original.tablaPuntaje) resultado.tablaPuntaje = original.tablaPuntaje;
      }

      resultado.mejorCoincidencia = coincidenciaFinal;
      this.resultadoAgente3 = resultado;

      this.map.setCenter(center);
      this.map.setZoom(15);

      new google.maps.Marker({
        position: center,
        map: this.map,
        label: '3',
        title: 'Agente 3'
      });

      new google.maps.Circle({
        strokeColor: '#ff5722',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#ff5722',
        fillOpacity: 0.35,
        map: this.map,
        center: center,
        radius: 50
      });
    } else {
      this.resultadoAgente3 = null;
    }
  } catch (error) {
    console.error('❌ Error Agente 3 desde búsqueda:', error);
    this.resultadoAgente3 = null;
  }
}















}
